module.exports = function() {
  return new Worker(__webpack_public_path__ + "db62691ede2059ca2b85.worker.js");
};